import $ from "jquery";
import videojs from "video.js";
import Storage from "@bd-utils/storage";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import CONFIG from "@bd-core/config";
import { getState } from "@bd-stores/store";
import { getRoomAnswerById } from "@bd-stores/game-data";
import {
    getTeamAnswers,
    getFinalTeamAnswers,
    getRoomStatus,
} from "@bd-stores/game-progress";
import CompletionPopup from "@bd-utils/completion-popup";
import Incidents from "@bd-utils/incidents";
import Feedbacks from "@bd-utils/feedback";
import Recap from "@bd-utils/recap";
import Screen from "@bd-utils/screen";
import {
    getRoomAnswers,
    maybeUpdateRoomStatus,
    updateRoomAnswer,
    updateFinalRoomAnswer,
} from "@bd-core/firebase-actions";
import GameLogic from "@bd-core/game-logic";

export class RoomMultipleQuestion extends BD_Component {
    constructor() {
        super();

        this.id = "multiple_question";
        this.templateID = "multiple_question-template";

        this.elms = {
            closeQuestion: ".js-multipleQuestions-close",
            openQuestion: ".js-multipleQuestions-open",
            questionPopup: ".js-multiple-questions-question",
            booleanAnswer: ".js-boolean-answer",
            booleanItem: ".js-question",
            answers: ".js-answers",
            checkBtn: ".js-check-answer",
            check: ".js-action",
            count: ".count",
            correct: ".js-correct",
            middle: ".js-middle",
            wrong: ".js-wrong",
            roomStatus: ".js-room-status",
            background: ".js-screen-img",
            backgroundImage: ".screen__navigate",
            closeButtonPopup: ".multipleQuestions__close",
            backButton: ".app__back",
            timer: ".js-timer",
            audioBox: ".js-multipleQuestions-audio",
            questionBox: ".js-multipleQuestions-question",
            ringtone: ".js-ringtone",
            acceptCall: ".js-play-audio",
            callPlayer: ".js-phone",
            challengeAudio: ".js-audio-challenge",
            skipbutton: ".js-skip-audio",
            goToQuestionBtn: ".js-continue-question",
            finishIncident: ".js-finish-incident",
            finishFeedback: ".js-finish-feedback",
            toggleDilemma: ".js-toggle-dilemma",
            selectAnswers: ".js-select-answer",
            pickAnswer: ".js-answer-drop",
            submitAnswer: ".js-submit-answer",
            backToRoom: ".js-back-mq",
            closeDilemma: ".js-close-dilemma",
            hotspotCoordinate: ".js-challenge-coordinate",
            finishRecap: ".js-finish-recap",
            openHint: ".js-hint-open",
            closeHint: ".js-close-video-popup",
            hintPopup: ".js-video-popup",
        };

        this._events = this.getEvents();

        this.completionPopup = new CompletionPopup();
        this.incident = new Incidents();
        this.feedback = new Feedbacks();
        this.recap = new Recap();

        this.hotspotSize = 25.5;
        this.timerWarningDuration = 2000; // milliseconds
        this.timerWarningClass = "timer-warning";
        this.userAnswers = {};

        this.meSubmittingAnswer = false;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.openQuestion,
                handler: this.onQuestionToggler,
            },
            {
                event: "click",
                selector: elms.closeQuestion,
                handler: this.onQuestionToggler,
            },
            // {
            //     event: "change",
            //     selector: elms.booleanAnswer,
            //     handler: this.onAnswerBoolean,
            // },
            {
                event: "click",
                selector: elms.checkBtn,
                handler: this.onIndividualCheck,
            },
            {
                event: "click",
                selector: elms.acceptCall,
                handler: this.playChallengeAudio,
            },
            {
                event: "click",
                selector: elms.skipbutton,
                handler: this.skipAudio,
            },
            {
                event: "click",
                selector: elms.goToQuestionBtn,
                handler: this.proceedToQuestion,
            },
            {
                event: "click",
                selector: elms.finishIncident,
                handler: this.finishIncidents,
            },
            {
                event: "click",
                selector: elms.finishRecap,
                handler: this.finishRecap,
            },
            {
                event: "click",
                selector: elms.finishFeedback,
                handler: this.finishFeedback,
            },
            {
                event: "click",
                selector: elms.toggleDilemma,
                handler: this.toggleDilemapopup,
            },
            {
                event: "click",
                selector: elms.selectAnswers,
                handler: this.toggleAnswers,
            },
            {
                event: "click",
                selector: elms.pickAnswer,
                handler: this.pickAnswer,
            },
            {
                event: "click",
                selector: elms.submitAnswer,
                handler: this.submitAnswer,
            },
            {
                event: "click",
                selector: elms.backToRoom,
                handler: this.onQuestionToggler,
            },
            {
                event: "click",
                selector: elms.closeDilemma,
                handler: this.onCloseDilemmaPopup,
            },
            {
                event: "click",
                selector: elms.openHint,
                handler: this.onOpenHint,
            },
            {
                event: "click",
                selector: elms.closeHint,
                handler: this.onCloseHint,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
        this.maybeThisRoomIsLastRoom();
        window.screenCalculationFunc = () => Screen.calculateCoverSize();
    }

    getModifiedData() {
        const modified = { ...this._data };
        const self = this;
        let _challenge = this._data.challenges;
        const defaultNormalImage = `${CONFIG.themeURL}/assets/images/multiplequestion-item-new.png`;
        const defaultHoverImage = `${CONFIG.themeURL}/assets/images/multiplequestion-item-hover-new.png`;
        const defaultImageBg = `${CONFIG.themeURL}/assets/images/bg-multiple-questions-new.png`;

        const _image_bg = this._data.image_bg
            ? this._data.image_bg
            : defaultImageBg;

        _challenge = {
            normal_image: _challenge?.normal_image
                ? _challenge?.normal_image
                : defaultNormalImage,
            hover_image: _challenge?.hover_image
                ? _challenge?.hover_image
                : defaultHoverImage,
        };

        let questionHotspots = this._data.hotspots.filter(
            (h) => h.hotspot_type === "question",
        );

        $.each(this._data.questions, function (i, question) {
            if (questionHotspots[i]) {
                question.position_left = questionHotspots[i].position_left;
                question.position_top = questionHotspots[i].position_top;
                question.index = self._data.hotspots.findIndex(
                    (h) => h === questionHotspots[i],
                );
            }
        });

        const hintHotspots = this._data.hotspots.filter(
            (h) => h["hotspot_type"] === "hint",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";

        const _hints = this._data.hints.map((hint, i) => {
            return {
                ...hint,
                index: self._data.hotspots.findIndex(
                    (h) => h === hintHotspots[i],
                ),
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const modifiedData = {
            ...modified,
            hints: _hints,
            challenges: _challenge ?? {},
            image_bg: _image_bg ?? defaultImageBg,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);

        this.incident.init();
        this.feedback.init(modifiedData);

        this.feedback.currentRoomId = this.roomId;
        this.incident.currentRoomId = this.roomId;

        this.hideClickHereTextJustForThisRoom();
    }

    setGameState() {
        const self = this;
        const elms = this.elms;
        const roomId = this.roomId;
        const roomAnswers = getFinalTeamAnswers(roomId);
        const teamAnswers = getTeamAnswers(roomId);
        const thisRoomStatus = getRoomStatus(roomId);

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        // const updateHotspotState = function (answers, type) {
        //     const lastCoordinateId = Array.isArray(answers)
        //         ? answers[answers.length - 1]
        //         : Object.keys(answers)[Object.keys(answers).length - 1];
        //     let lastCoordinateIndex = null;

        //     if (type === "question") {
        //         const $lastCoordinate = $(
        //             `.js-challenge-coordinate[data-id="${lastCoordinateId}"]`,
        //         );
        //         lastCoordinateIndex = $lastCoordinate
        //             .find(".js-screen-hotspot")
        //             .attr("data-index");
        //     } else {
        //         const $lastCoordinate = $(
        //             `.js-hint-coordinate[data-id="${lastCoordinateId}"]`,
        //         );
        //         lastCoordinateIndex = $lastCoordinate.attr("data-index");
        //     }

        //     const nextIndex = Number(lastCoordinateIndex) + 1;
        //     const $nextCoordinate = $(
        //         `.js-screen-hotspot[data-index="${nextIndex}"]`,
        //     );
        //     const isNextElementAHint = $nextCoordinate.hasClass("js-hint-open");

        //     if (isNextElementAHint) {
        //         $nextCoordinate.removeClass("is-disabled");
        //     } else {
        //         $nextCoordinate.parent().removeClass("is-disabled");
        //     }
        // };

        const setSelectedAnswers = function (answers) {
            let isFromFinalAnswers = false;

            $.each(answers, function (questionID, objAnswer) {
                const answerValue = objAnswer?.answer || objAnswer;
                const questionId = String(questionID);
                const isFinalAnswer =
                    roomAnswers?.[questionID]?.answer === answerValue;
                isFromFinalAnswers = isFinalAnswer;

                const $questionHotspot = $(
                    `.js-dilemma-asnwers[data-question-id="${questionId}"]`,
                );

                $questionHotspot
                    .find(`.js-answer-drop`)
                    .removeClass("is-selected");

                $questionHotspot
                    .find(`.js-answer-drop[data-answer-id=${answerValue}]`)
                    .addClass("is-selected");

                if (isFinalAnswer) {
                    $questionHotspot
                        .find(elms.submitAnswer)
                        .prop("disabled", true);

                    $(
                        `${elms.hotspotCoordinate}[data-id="${questionId}"]`,
                    ).addClass("is-active is-finished");
                } else {
                    self.toggleCheckButton(questionId);
                }

                self.feedback.setFeedback(questionID, answerValue, self._data);
            });

            if (isFromFinalAnswers) {
                // self.updateHostpotState(answers, "question");
            }
        };

        if (
            Object.keys(teamAnswers).length ===
                Object.keys(roomAnswers).length &&
            Object.keys(roomAnswers).length > 0
        ) {
            setSelectedAnswers(roomAnswers);
            this.incident.populateIncidents(roomAnswers, this._data);
        } else {
            setSelectedAnswers(teamAnswers);
        }

        const questions = this._data.questions;
        if (Object.keys(questions).length === Object.keys(roomAnswers).length) {
            const roomStatus = "is-status-completed";
            maybeUpdateRoomStatus(roomId, roomStatus);
        }

        if (thisRoomStatus === "is-status-completed") {
            // if (!this.meSubmittingAnswer)
            //     $(elms.check).removeClass("is-checked");

            $(elms.questionPopup).addClass("is-completed");
            $(".app__page").addClass("is-room-completed");

            $(`.js-challenge-coordinate`).addClass("is-finished");

            // this.incident.populateIncidents(roomAnswers, this._data);

            // GameLogic.goToPage(this._data.mainroom_id);

            /* Show completion popup */
            // this.completionPopup.show(roomId);
        }

        getRoomAnswers(roomId).then((data) => {
            this.updateUserChoicesList(data);
        });

        if ($(window).width() / $(window).height() === 1.6) {
            this.hotspotSize += 2.5;
            $(".js-challenge-coordinate")[0].style["top"] = "52.4%";
            $(".js-challenge-coordinate")[0].style["left"] = "35.8%";
        }

        // const hintCoordinates = $(".js-hint-coordinate[data-index]");
        // $.each(hintCoordinates, function () {
        //     const $hintCoordinate = $(this);
        //     const hintIndex = Number($hintCoordinate.attr("data-index"));

        //     if (hintIndex === 0) {
        //         $hintCoordinate
        //             .addClass("is-active")
        //             .find(".js-screen-hotspot")
        //             .removeClass("is-disabled");
        //     }
        // });

        let states = Storage.get("states", {});
        if (states?.hints && states.hints.length > 0) {
            $.each(states.hints, function (index, hintId) {
                const $hintCoordinate = $(
                    `.js-hint-coordinate[data-id="${hintId}"]`,
                );
                $hintCoordinate.addClass("is-finished");
                $hintCoordinate
                    .find(".js-screen-hotspot")
                    .addClass("is-disabled");
            });

            this.updateHostpotState(states.hints, "hint");
        }

        $(elms.closeButtonPopup).addClass("hidden");
        $(elms.backButton).addClass("up-front");
    }

    maybeThisRoomIsLastRoom() {
        const roomId = this.roomId;
        const rooms = CONFIG.game.rooms;

        // @ts-ignore
        const lastChallenge = rooms.findLast(
            // @ts-ignore
            (item) => item.hotspot_type === "challenge",
        );
        const lastChallengeId = lastChallenge.id;

        if (roomId === lastChallengeId) {
            $("#page-multiple-questions").addClass("is-last-room");
        }
    }

    finishIncidents() {
        // this.incident.hide();
        // this.feedback.show();
    }

    toggleDilemapopup(e) {
        const $el = $(e.currentTarget);
        const hasOpen = $el.hasClass("is-open");
        const isOpened = !hasOpen;
        // const $dilemma = $(".multipleQuestions__item");
        const $dilemmaParent = $el.parents(".multipleQuestions__item");
        const $popup = $dilemmaParent.find(".hotspot__popup");
        const $toggler = $dilemmaParent.find(".hotSpot__button");

        const $parent = $el.parents(".js-challenge-coordinate");

        if ($parent.hasClass("is-disabled")) return;

        if ($parent.hasClass("is-finished")) return;

        // $dilemma.each(function() {
        //     const $this = $(this);

        //     $this.find(".hotSpot__button").removeClass("is-open");
        //     $this.find(".hotSpot__popup").removeClass("is-open");
        // });

        $toggler.toggleClass("is-open", isOpened);
        $popup.toggleClass("is-open", isOpened);

        this.moveHotspotPopup($el);
    }

    onCloseDilemmaPopup() {
        const $dilemma = $(this.elms.toggleDilemma);
        const $parents = $dilemma.parents(".js-challenge-coordinate");

        $dilemma.removeClass("is-open");

        if (!$parents.length) {
            $dilemma.removeClass("is-hover");
        }

        $(this.elms.checkBtn).prop("disabled", true);
        this.hideClickHereTextJustForThisRoom();
    }

    backToRoom() {
        $(this.elms.backToRoom).trigger("click");

        const roomStatus = getRoomStatus(this.roomId);

        if (roomStatus === "is-status-completed") {
            GameLogic.goToPage(this._data.mainroom_id);
        }
    }

    moveHotspotPopup($el) {
        const $hotspotPopup = $el.siblings(".hotSpot__popup");
        const $hotspotButton = $el;
        const popupWidth = $hotspotPopup.width();
        const gapToRightEdge =
            window.innerWidth -
            $hotspotButton.offset().left -
            $hotspotPopup.width() / 3;

        if (gapToRightEdge < popupWidth) {
            $hotspotPopup.addClass("is-right");
        } else {
            $hotspotPopup.removeClass("is-right");
        }
    }

    toggleAnswers(e) {
        const elms = this.elms;
        const $this = $(e.currentTarget);

        if (!$this.length) return;

        const questionId = $this.attr("data-question-id");
        const $toggleAnswer = $(
            `${elms.selectAnswers}[data-question-id="${questionId}"]`,
        );
        const hasActive = $toggleAnswer.hasClass("is-active");
        const isActive = !hasActive;

        $toggleAnswer.toggleClass("is-active", isActive);
    }

    pickAnswer(e) {
        const $this = $(e.currentTarget);
        const questionID = $this.parent().attr("data-question-id");
        const theAnswer = $this.attr("data-answer-id");

        $this.addClass("is-selected");
        $this.siblings().removeClass("is-selected");

        this.toggleCheckButton(questionID);
        this.updateTempUserAnswer(questionID, theAnswer);
    }

    submitAnswer(e) {
        const $this = $(e.currentTarget);
        let $parent = $this.parents(".js-multiple-questions-question");

        if (!$parent.length) {
            $parent = $this.parents(".js-challenge-coordinate");
        }

        const questionId = $parent.attr("data-id");
        const $selectedAnswer = $this
            .parents(".js-dilemma-asnwers")
            .find(".js-answer-drop.is-selected");
        const answerSelected = $selectedAnswer.attr("data-answer");
        const answerId = $selectedAnswer.attr("data-answer-id");
        const $toggleAnswer = $(
            `${this.elms.selectAnswers}[data-question-id="${questionId}"]`,
        );

        $toggleAnswer.find(".corneredButton").addClass("is-selected");
        $toggleAnswer
            .find(".selectAnswer")
            .addClass("is-checkbox")
            .text(answerSelected);
        $toggleAnswer.find(".selectAnswer").attr("data-answer-id", answerId);
        $(this.elms.checkBtn).removeAttr("disabled");

        this.userAnswers = {
            questionId: questionId,
            answerId: answerId,
            answer: answerSelected,
        };

        $parent.find(this.elms.checkBtn).prop("disabled", false);
        this.toggleAnswers(e);
    }

    // ============================== CUSTOM FUNCTION

    /**
     * Decide whether to disabled or enabled boolean action (Check btn)
     *
     */
    toggleCheckButton(questionId) {
        const elms = this.elms;
        const $openedDilemma = $(
            `.js-dilemma-asnwers[data-question-id="${questionId}"]`,
        );
        const $answerOptions = $openedDilemma.find(elms.pickAnswer);
        let isAnsweredAll = false;

        $answerOptions.each(function () {
            const isSelected = $(this).hasClass("is-selected");
            if (isSelected) {
                isAnsweredAll = true;
                return false;
            }
        });

        $openedDilemma.find(elms.submitAnswer).prop("disabled", !isAnsweredAll);
    }

    getSavedAnswers() {
        const roomID = this.roomId;
        const states = Storage.get("states", {});
        const savedAnswers = states?.answers?.[roomID] || {};

        return savedAnswers;
    }

    setSavedAnswers(answers) {
        const roomID = this.roomId;
        let states = Storage.get("states", {});
        if (!states?.answers) states.answers = {};
        if (!states?.answers?.[roomID]) states.answers[roomID] = {};
        states.answers[roomID] = answers;

        return Storage.set("states", states);
    }

    /**
     * Save answer for particular questionId into local storage
     * @param {string} questionId
     * @param {string} value
     */
    saveAnswer(questionId, value, isGotIncident, percentage) {
        let savedAnswers = this.getSavedAnswers();
        // savedAnswers[questionId] = value;

        savedAnswers[questionId] = {
            answer: value,
            isGotIncident: isGotIncident || false,
            incidentPercentage: percentage || 0,
            isMiddleState: false,
        };

        const questionData = this._data.questions.find(
            (q) => q.question_id === questionId,
        );
        const answerData = questionData?.answers.find(
            (a) => a.answer_id === value,
        );
        const feedback = answerData?.feedback;

        if (feedback && feedback.action_cost) {
            this.feedback.saveActionCost(feedback.action_cost);
        }

        // this.incident.populateIncidents(savedAnswers, this._data);

        this.setSavedAnswers(savedAnswers);
        this.updateUserAnswer(savedAnswers);
    }

    // onAnswerBoolean(e, el) {
    //     const $this = $(el);
    //     const elms = this.elms;
    //     const $boolean = $this.parents(elms.questionPopup);
    //     const incident = this.incident;

    //     if ($boolean.hasClass("is-completed")) {
    //         return false;
    //     }

    //     //save the answer into local storage
    //     const questionID = $this.parents(elms.booleanItem).attr("data-id");
    //     const theAnswer = $this.attr("data-id");
    //     const answerData = this._data.questions
    //         .find((q) => q.question_id === questionID)
    //         .answers.find((a) => a.answer_id === theAnswer);
    //     const isGotIncident = incident.isGotIncident(
    //         answerData.incident.incident_percentage,
    //     );
    //     this.saveAnswer(
    //         questionID,
    //         theAnswer,
    //         isGotIncident,
    //         answerData.incident.incident_percentage,
    //     );

    //     const inputParent = $this.parents(elms.answers);
    //     inputParent.find(elms.booleanAnswer).removeClass("is-active");
    //     $this.addClass("is-active");
    //     this.toggleCheckButton();
    // }

    onIndividualCheck(e, el) {
        const elms = this.elms;
        const $el = $(el);

        if ($el.hasClass("is-loading") || $el.hasClass("is-completed")) return;

        $el.parent().removeClass("is-checked");
        $el.addClass("is-loading").prop("disabled", true);

        const incident = this.incident;
        const answerData = this._data.questions
            .find((q) => q.question_id === this.userAnswers.questionId)
            .answers.find((a) => a.answer_id === this.userAnswers.answerId);
        const isGotIncident = incident.isGotIncident(
            answerData.incident.incident_percentage,
        );

        const roomID = this.roomId;
        const roomAnswer = getRoomAnswerById(roomID);
        let roomStatus = "is-status-started";

        this.saveAnswer(
            this.userAnswers.questionId,
            this.userAnswers.answerId,
            isGotIncident,
            answerData.incident.incident_percentage,
        );

        this.feedback.setFeedback(
            this.userAnswers.questionId,
            this.userAnswers.answerId,
            this._data,
        );

        const userAnswers = getFinalTeamAnswers(this.roomId);
        this.incident.populateIncidents(userAnswers, this._data);
        this.incident.currentRoomId = roomID;

        this.meSubmittingAnswer = true;

        if (
            Object.keys(userAnswers).length === Object.keys(roomAnswer).length
        ) {
            roomStatus = "is-status-completed";
            // this.meSubmittingAnswer = true;

            $el.parent().addClass("is-completed");
            $el.parents(elms.questionPopup).addClass("is-completed");
            $(`.js-challenge-coordinate`).addClass("is-finished");
        } else {
            $el.removeClass("is-loading").removeAttr("disabled");

            $(
                `.js-challenge-coordinate[data-id="${this.userAnswers.questionId}"]`,
            ).addClass("is-finished is-active");
        }

        maybeUpdateRoomStatus(roomID, roomStatus);
    }

    getTimeRisk(roomAnswers, playerAnswer) {
        if (!roomAnswers || !playerAnswer) return null;

        for (var key in roomAnswers) {
            if (Array.isArray(roomAnswers[key])) {
                var found = $.grep(roomAnswers[key], function (item) {
                    return item.answer_id === playerAnswer;
                });

                if (found.length > 0) {
                    return found[0].time_risk;
                }
            }
        }
        return null; // not found
    }

    onQuestionToggler(e) {
        const elms = this.elms;
        const $this = $(e.currentTarget);
        const $parent = $this.parents(".js-challenge-coordinate");

        if ($parent.hasClass("is-disabled")) return;

        if ($parent.hasClass("is-finished")) return;

        $(elms.checkBtn).prop("disabled", true);

        const id = $parent.attr("data-id");

        $(elms.questionPopup).removeClass("is-open");

        $(elms.toggleDilemma).removeClass("is-open");

        if (!id) return;

        const $popupElement = $(`${elms.questionPopup}[data-id="${id}"]`);

        const hasOpen = $popupElement.hasClass("is-open");
        const isOpened = !hasOpen;
        $popupElement.toggleClass("is-open", isOpened);
    }

    playChallengeAudio() {
        const elms = this.elms;
        $(elms.callPlayer).addClass("audio-playing");
        const ringtoneEl = this.getMediaElement(elms.ringtone);
        const challengeEl = this.getMediaElement(elms.challengeAudio);
        ringtoneEl && ringtoneEl.pause();
        challengeEl && challengeEl.play();
    }

    skipAudio() {
        const elms = this.elms;
        const challengeEl = this.getMediaElement(elms.challengeAudio);
        challengeEl && challengeEl.pause();
        $(elms.callPlayer).removeClass("audio-playing");
        $(elms.callPlayer).addClass("audio-stop");
    }

    proceedToQuestion() {
        const elms = this.elms;

        $(elms.audioBox).addClass("is-closed");
        $(elms.questionBox).addClass("is-open");
    }

    /**
     * Safely get an HTMLMediaElement from a selector
     * @param {string} selector
     * @returns {HTMLMediaElement|null}
     */
    getMediaElement(selector) {
        const el = $(selector).get(0);
        return el instanceof HTMLMediaElement ? el : null;
    }

    onForceOppenChallenge() {
        const elms = this.elms.questionPopup;
        const closeButton = this.elms.closeButtonPopup;
        const backButton = this.elms.backButton;

        const blur = $(".app-blur");

        blur.addClass("is-blurred");

        $(elms).addClass("is-open");
        $(closeButton).addClass("hidden");
        $(backButton).addClass("up-front");
    }

    updateUserAnswer(answers) {
        const roomId = this.roomId;

        updateFinalRoomAnswer(roomId, answers);
    }

    updateTempUserAnswer(questionId, answer) {
        const roomId = this.roomId;

        updateRoomAnswer(roomId, {
            [questionId]: answer,
        });
    }

    updateUserChoicesList(answer) {
        if ($("#locationInfo-item").length < 1) return;

        const fbRoomAnswers = answer.val() ?? {};
        const players = getState().gameProgress.players;
        const template = $("#locationInfo-item").html();

        // Filter the player to not include the current user
        const onlinePlayers = players.filter(
            (player) => player.isOnline && player.userId !== CONFIG.user.id,
        );

        $(".userChoice_list").each(function () {
            const $context = $(this).parents(".js-userChoices-context");
            const hasContext = $context.length > 0;

            const questionID = hasContext
                ? $context.attr("data-question-id")
                : undefined;
            const questionAnswerID = hasContext
                ? $context.attr("data-answer-id")
                : undefined;

            const users = onlinePlayers.filter((player) => {
                const usrID = player.userId;
                const thisPlayerAnswer = fbRoomAnswers[usrID]?.choice;

                if (typeof thisPlayerAnswer !== "object") {
                    return;
                }

                if (thisPlayerAnswer[questionID] == questionAnswerID) {
                    return player;
                }
            });

            const html = compile(template, { players: users });
            $(this).html(html);
        });
    }

    enableHintsUpToIndex(targetIndex) {
        const hintCoordinates = $(".js-hint-coordinate[data-index]");

        hintCoordinates.each(function () {
            const $hintCoordinate = $(this);
            const hintIndex = Number($hintCoordinate.attr("data-index"));

            if (hintIndex <= targetIndex || hintIndex === 0) {
                $hintCoordinate
                    .find(".js-screen-hotspot")
                    .removeClass("is-disabled");
            }
        });
    }

    updateHostpotState(answers, type) {
        // const currentElement = $(
        //     `.js-challenge-coordinate[data-id="${this.userAnswers.questionId}"]`,
        // );

        // const currentIndex = currentElement
        //     .find(".js-screen-hotspot")
        //     .attr("data-index");
        // const nextElement = $(
        //     `.js-screen-hotspot[data-index="${Number(currentIndex) + 1}"]`,
        // );
        // const isNextElementAHint = nextElement.hasClass("js-hint-open");

        // this.onCloseDilemmaPopup();

        // if (nextElement.length > 0) {
        //     if (isNextElementAHint) {
        //         nextElement.removeClass("is-disabled");
        //     } else {
        //         nextElement.parent().removeClass("is-disabled");
        //     }
        // }

        const lastCoordinateId = Array.isArray(answers)
            ? answers[answers.length - 1]
            : Object.keys(answers)[Object.keys(answers).length - 1];
        let lastCoordinateIndex = null;

        if (type === "question") {
            const $lastCoordinate = $(
                `.js-challenge-coordinate[data-id="${lastCoordinateId}"]`,
            );
            lastCoordinateIndex = $lastCoordinate
                .find(".js-screen-hotspot")
                .attr("data-index");
        } else {
            const $lastCoordinate = $(
                `.js-hint-coordinate[data-id="${lastCoordinateId}"]`,
            );
            lastCoordinateIndex = $lastCoordinate.attr("data-index");
        }

        const nextIndex = Number(lastCoordinateIndex) + 1;
        const $nextCoordinate = $(
            `.js-screen-hotspot[data-index="${nextIndex}"]`,
        );
        const isNextElementAHint = $nextCoordinate.hasClass("js-hint-open");

        if (isNextElementAHint) {
            $nextCoordinate.removeClass("is-disabled");
        } else {
            $nextCoordinate.parent().removeClass("is-disabled");
        }
    }

    finishFeedback() {
        this.onCloseDilemmaPopup();
        this.feedback.hide();

        const roomAnswers = getFinalTeamAnswers(this.roomId);
        this.updateHostpotState(roomAnswers, "question");
        this.hideClickHereTextJustForThisRoom();
    }

    finishRecap() {
        this.recap.hide();
        this.backToRoom();
    }

    handleHintVideo(file) {
        if (!file) return;

        const $hintPopup = $(this.elms.hintPopup);
        let hintVideo = videojs.getPlayer("hint-video");

        $hintPopup.find(".js-image-content").hide();
        $hintPopup.find(".js-video-content").show();

        if (!hintVideo) {
            hintVideo = videojs("hint-video", {
                controls: false,
                autoplay: true,
                preload: "auto",
                techOrder: ["html5"],
            });

            // handle on error video
            hintVideo.on("error", function () {
                console.error("Can't play the video");
            });
        }

        hintVideo.src({
            src: file,
            type: "video/mp4",
        });

        hintVideo.currentTime(0);

        $hintPopup.addClass("is-open");

        try {
            hintVideo.play().catch((error) => {
                // Autoplay was blocked. Do something
                console.error("Unable to start auto play", error);
            });
        } catch (error) {
            console.error(error);
        }
    }

    handleHintImage(file) {
        if (!file) return;

        const $hintPopup = $(this.elms.hintPopup);
        const $imageContent = $hintPopup.find(".js-image-content");
        const $theImage = $imageContent.find("img");

        $hintPopup.find(".js-video-content").hide();
        $hintPopup.find(".js-image-content").show();

        $theImage.attr("src", file).attr("alt", "Hint Image");
        $hintPopup.addClass("is-open");
    }

    saveHintOpenedState(hintId) {
        let states = Storage.get("states", {});
        if (!states?.hints) states.hints = [];

        const hasSeen = states.hints.includes(hintId);
        if (!hasSeen) {
            states.hints.push(hintId);
            Storage.set("states", states);
        }
    }

    getHintOpenedState(hintId) {
        let states = Storage.get("states", {});
        if (!states?.hints) states.hints = [];

        return states.hints.includes(hintId);
    }

    onOpenHint(e) {
        const $el = $(e.currentTarget);
        const $parent = $el.parents(".js-hint-coordinate");
        const hintId = $parent.attr("data-id");
        const mediaType = $parent.attr("data-media-type");
        const file = $parent.attr("data-file");
        const isDisabled = $el.hasClass("is-disabled");

        if (isDisabled) return;

        $(".js-video-popup").attr("data-id", hintId);

        if (mediaType === "video") {
            this.handleHintVideo(file);
        } else if (mediaType === "image") {
            this.handleHintImage(file);
        } else {
            console.error("Invalid media type");
        }

        this.saveHintOpenedState(hintId);

        // updateHintIsOpened(this.roomId, userId, hintId);
    }

    onCloseHint() {
        const elms = this.elms;
        const $hintPopup = $(elms.hintPopup);
        const hintId = $hintPopup.attr("data-id");
        const hintVideo = videojs.getPlayer("hint-video");

        if (hintVideo) {
            hintVideo.pause();
        }

        const updateHotspotState = function (hintId) {
            const $hintCoordinate = $(
                `.js-hint-coordinate[data-id="${hintId}"]`,
            );
            const coordinateIndex = $hintCoordinate.attr("data-index");
            const nextIndex = Number(coordinateIndex) + 1;
            const $nextCoordinate = $(
                `.js-screen-hotspot[data-index="${nextIndex}"]`,
            );
            const isNextElementAHint = $nextCoordinate.hasClass("js-hint-open");

            $hintCoordinate.addClass("is-finished");
            $hintCoordinate.find(".js-screen-hotspot").addClass("is-disabled");

            if (isNextElementAHint) {
                $nextCoordinate.removeClass("is-disabled");
            } else {
                $nextCoordinate.parent().removeClass("is-disabled");
            }
        };

        updateHotspotState(hintId);
        $hintPopup.removeClass("is-open");
        this.hideClickHereTextJustForThisRoom();
    }

    hideClickHereTextJustForThisRoom() {
        const hintCoordinates = $(".js-hint-coordinate");

        hintCoordinates.each(function () {
            const isNotDisabled = !$(this)
                .find(".js-screen-hotspot")
                .hasClass("is-disabled");

            if (isNotDisabled) {
                $(this).removeClass("hide-click-here");
            } else {
                $(this).addClass("hide-click-here");
            }
        });
    }
}
